import { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";

const cleanText = (text) => {
  if (typeof text !== "string") return "";

  return text
    .replace(/restaurantname[:]?/gi, "")
    .replace(/restaurant name[:]?/gi, "")
    .replace(/اسم المطعم[:]?/gi, "")
    .trim();
};

const useDynamicTranslation = (dataList = []) => {
  const { lang } = useLang();
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    setTranslations({});
  }, [lang]);

  const translateViaBackend = async (text) => {
    try {
      const apiBase = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
      const res = await fetch(`${apiBase}/translation/translate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ text })
      });

      if (!res.ok) {
        throw new Error(`Server returned ${res.status}`);
      }

      const data = await res.json();
      return data[lang] || text;
    } catch (err) {
      console.error(err);
      return text;
    }
  };

  useEffect(() => {
    if (!dataList.length || lang === "en") return;

    const translateAll = async () => {
      const newTranslations = {};

      const uniqueToTranslate = Array.from(new Set(
        dataList
          .map(text => cleanText(text))
          .filter(cleaned => cleaned && cleaned.length > 0 && !translations[cleaned])
      ));

      if (uniqueToTranslate.length === 0) return;

      await Promise.all(
        uniqueToTranslate.map(async (cleaned) => {
          const translated = await translateViaBackend(cleaned);
          if (translated && translated !== cleaned) {
            newTranslations[cleaned] = translated;
          }
        })
      );

      if (Object.keys(newTranslations).length > 0) {
        setTranslations((prev) => ({
          ...prev,
          ...newTranslations
        }));
      }
    };

    translateAll();
  }, [dataList, lang]);

  const getText = (data) => {
    if (!data) return "";

    const text =
      typeof data === "object"
        ? data.en || Object.values(data)[0]
        : String(data);

    const cleaned = cleanText(text);

    if (lang !== "en" && translations[cleaned]) {
      return translations[cleaned];
    }

    return cleaned;
  };

  return { getText };
};

export default useDynamicTranslation;